import { render, staticRenderFns } from "./doctorClinic.vue?vue&type=template&id=29f7f795&scoped=true&"
import script from "./doctorClinic.vue?vue&type=script&lang=js&"
export * from "./doctorClinic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f7f795",
  null
  
)

export default component.exports